import {TranslationFunction} from "../../i18n/i18n";
import {CatalogFormatter} from "../../common/catalog/CatalogFormatter";
import {IsdsMessageState} from "../../client/message/IsdsMessageApiClient";

export class MessageStatusFormatter {
    static formatMessageStatusStatus(subscriptionStatus: IsdsMessageState | null | undefined, t: TranslationFunction): string {
        return CatalogFormatter.formatCatalogValueByCode(subscriptionStatus, "messageCurrentStatus", t);
    }
}
